module.exports = __webpack_public_path__ + "img/rianti.64e51069.png";